import React from 'react';
import { message } from 'antd';
import { LikeButton } from '../likeButton';
import { ProductInfoHeaderProps } from '../interfaces';

import './ProductInfoHeader.scss';

const ProductInfoHeader: React.FC<ProductInfoHeaderProps> = ({ productId, title }) => (
  <>
    <h2 className="productId-title">{title}</h2>
    <div className="heart-icon">
      <LikeButton
        productId={productId}
        iconSize={20}
        onAuthRequired={() => message.warning('Please log in to continue.')}
      />
    </div>
  </>
);

export default ProductInfoHeader;
